import React from 'react';

const OhiIntroDescription = (
  <>
    <h2 className="vads-u-font-size--h3">
      Report Medicare and other non-VA health insurance
    </h2>
    <p>
      Now we’ll ask you questions about Medicare and any other non-VA health
      insurance the applicants have. We need this information to process their
      application for CHAMPVA benefits.
    </p>
    <h3 className="vads-u-font-size--h4">
      What to know before filling out this form
    </h3>
    <ul className="no-bullets">
      <li>
        <strong className="vads-u-display--block">
          If the applicants have Medicare or other health insurance
        </strong>
        You’ll need to submit copies of the Medicare or other health insurance
        cards (front and back).
      </li>
      <li>
        <strong className="vads-u-display--block">
          If the applicants don’t have Medicare or other health insurance
        </strong>
        You may need to submit proof of ineligibility or disallowance (lack of
        coverage).
      </li>
    </ul>
    <p>
      <strong>Note:</strong> We don’t need the insurance information for the
      Veteran sponsoring the applicants.
    </p>
  </>
);

export default OhiIntroDescription;
